import { EORDER_STATUS, EORDER_TYPE } from "@constants";
import { IOrder } from "../interface/IOrder";

export interface IOrderOfferResponse {
    name: string;
    isEligibleToCancel: boolean;
    oneOffChargeAmount: number;
    recurringChargeAmount: number;
    upFrontChargeAmount: number;
}

export interface IOrderResponse {
    createdDateTime: string;
    offers: IOrderOfferResponse[];
    orderType: keyof typeof EORDER_TYPE;
    reference: string;
    status: keyof typeof EORDER_STATUS;
    totalOneOffChargeAmount: number;
    totalRecurringChargeAmount: number;
    totalUpFrontChargeAmount: number;
}

export const getResponseToState = (response: IOrderResponse[]): IOrder[] =>
    response.map((order) => ({
        createdDateTime: order.createdDateTime,
        offers: order.offers.map((offer) => ({
            name: offer.name,
            isEligibleToCancel: offer.isEligibleToCancel,
            oneOffChargeAmount: offer.oneOffChargeAmount,
            recurringChargeAmount: offer.recurringChargeAmount,
            upFrontChargeAmount: offer.upFrontChargeAmount,
        })),
        orderType: order.orderType,
        reference: order.reference,
        status: order.status,
        totalOneOffChargeAmount: order.totalOneOffChargeAmount,
        totalRecurringChargeAmount: order.totalRecurringChargeAmount,
        totalUpFrontChargeAmount: order.totalUpFrontChargeAmount,
    }));
